import PageContainer from '@/common/components/PageContainer'
import CreateEventListing from '@/modules/events/components/CreateEventListing'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'

function CreateEventPage() {
	return (
		<PageContainer>
			<CreateEventListing />
		</PageContainer>
	)
}

const GuardedCreateEventPage = withUserPermission(CreateEventPage, {
	permissionType: PermissionType.Write,
	permissionKey: [PermissionKeys.WEB_SETTING],
})

export default GuardedCreateEventPage
